import { AuthConfig } from '@/libs/device-auth/services/authService';

// Default Auth0 configuration implementation
export class DefaultAuthConfig implements AuthConfig {
  clientId: string;
  audience: string;
  domain: string;
  issuer: string;

  constructor() {
    this.clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
    this.audience = import.meta.env.VITE_AUTH0_AUDIENCE;
    this.domain = import.meta.env.VITE_AUTH0_DOMAIN;
    this.issuer = `https://auth.${this.domain}`;
  }

  getTokenUrl(): string {
    return `${this.issuer}/oauth/token`;
  }

  getDeviceCodeUrl(): string {
    return `${this.issuer}/oauth/device/code`;
  }
}
